import { Button, Group, ScrollArea } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useState } from 'react';
export type ActionTabProps = {
  activeIndex: number;
  items: string[];
  miw: number;
};
export const ActionTab: React.FC<ActionTabProps> = ({
  items,
  activeIndex,
  miw
}) => {
  const [active, setActive] = useState(items[activeIndex]);
  const isMobile = useMediaQuery('(max-width: 36em)');
  const handleMenuClick = (menu: string) => {
    setActive(menu);
  };
  return <ScrollArea miw={miw} w={isMobile ? '35%' : ''} type="never">
      <Group ml="auto" pos="relative" wrap="nowrap" gap={4}>
        {items.map(item => <Button key={item} c="var(--text-white)" fw={700} radius={4} h={20} px={10} fz={{
        base: 10,
        md: 11
      }} variant={active === `${item}` ? 'gradient' : 'transparent'} gradient={{
        from: '#FF6EA9 10%',
        to: '#FF2E3E 90%',
        deg: 135
      }} autoContrast onClick={() => handleMenuClick(item)} tt="uppercase">
            {item}
          </Button>)}
      </Group>
    </ScrollArea>;
};